import DashboardStats from "./dashboardStas";
import ReusableTable from "../../../../components/TableComponent";
import { MasterConfigs } from "../../../../interfaces/entity";
import moment from "moment";
import { Button, Dropdown, Flex, Space, Typography } from "antd";
import StatusBadge from "./StatusBadge";
import { useEffect, useState } from "react";
import { MoreOutlined } from '@ant-design/icons';
import AttendanceRegularizationModal from "../AttendanceRegularizationModal";
import { MenuProps } from "antd/lib";
import { PartialDayRequestModal } from "../PartialDayRequestModal";

const { Text } = Typography

const AttendanceLog = () => {
    const [current, setCurrentDate] = useState<{ month: string, year: string }>()
    const [openModal, setOpenModal] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null);
    const [partialDayRequest, setPartialDayRequest] = useState(false);

    const attendanceConfig: MasterConfigs = {
        api: () => '/attendance-logs/user',
        queryParams: {
            month: current?.month,
            year: current?.year
        },
        modalTitle: () => 'Attendance Log',
        getColumns: () => [
            {
                title: 'Date',
                dataIndex: 'date',
                key: 'date',
                width: 100,
                render: (text: any, record: any) => {
                    return moment(text).format('dddd DD MMM, YYYY')
                }
            },
            {
                title: 'Shift',
                dataIndex: 'shiftId',
                key: 'shiftId',
                align: 'center',
                width: 100,
                render: (text: any, record: any) => {
                    return text?.name
                }
            },
            {
                title: 'Clock In',
                dataIndex: 'startDate',
                key: 'startDate',
                align: 'center',
                width: 100,
                onCell: (record) => {
                    let backgroundColor = '';

                    if (record.punchStatus == 'on-time') backgroundColor = '#d9f7be'; // red-ish
                    else backgroundColor = '#ffccc7'; // green-ish

                    if (!record?.startDate) {
                        backgroundColor = ''
                    }

                    return {
                        style: {
                            backgroundColor,
                        },
                    };
                },
                render: (text: any, record: any) => {
                    return text ?
                        <Flex justify="space-between">
                            {moment(text).format('hh:mm A')}
                            <span className={'first-letter:uppercase pl-2 -mt-1 font-semibold ' + (record?.punchStatus == 'on-time' ? 'text-green-700' : 'text-red-600')} >
                                {record?.punchStatus}
                            </span>
                        </Flex>
                        : '-'
                }
            },
            {
                title: 'Clock Out',
                dataIndex: 'endDate',
                key: 'endDate',
                align: 'center',
                width: 100,
                onCell: (record) => {
                    let backgroundColor = '';

                    if (record.punchOut == 'on-time' || record.punchOut == 'late') backgroundColor = '#d9f7be'; // red-ish
                    else backgroundColor = '#ffccc7'; // green-ish

                    if (!record?.endDate) {
                        backgroundColor = ''
                    }

                    return {
                        style: {
                            backgroundColor,
                        },
                    };
                },
                render: (text: any, record: any) => {
                    return text ?
                        <Flex justify="space-between">
                            {moment(text).format('hh:mm A')}
                            <span className={'first-letter:uppercase pl-2 -mt-1 font-semibold ' + ((record?.punchOut == 'on-time' || record?.punchOut == 'late') ? 'text-green-700' : 'text-red-600')} >
                                {record?.punchOut}
                            </span>
                        </Flex>
                        : '-'
                }
            },
            {
                title: 'Working Hours',
                dataIndex: 'totalTime',
                key: 'totalTime',
                align: 'center',
                width: 100,
                render: (text: any, record: any) => {
                    if (record.startDate && record.startDate) {
                        const startTime = moment(record.startDate)
                        const endTime = moment(record.endDate)
                        const duration = moment.duration(endTime.diff(startTime))
                        return duration.hours() + 'h ' + duration.minutes() + 'm'
                    } else {
                        return '-'
                    }
                }
            },
            {
                title: 'Location',
                dataIndex: 'formatted_address',
                key: 'formatted_address',
                width: 300,
                ellipsis: true,
                render: (text: any, record: any) => {
                    return text
                }
            },
            {
                title: 'Status',
                dataIndex: 'dayStatus',
                key: 'dayStatus',
                align: 'center',
                width: 100,
                render: (text: any, record: any) => {

                    return <Flex justify="space-between" align="center">
                        <StatusBadge status={text} />
                        <Dropdown menu={{
                            items, onClick: (e) => {
                                if (e.key === '0') {
                                    setSelectedDate(record.date);
                                    setOpenModal(true);
                                } else if (e.key === '1') {
                                    setPartialDayRequest(true);
                                }
                            }
                        }}>
                            <Button type="text" icon={<MoreOutlined />} />
                        </Dropdown>
                    </Flex >
                }
            },
        ]
    }


    const items: MenuProps['items'] = [
        {
            key: '0',
            label: 'Request Attendance Regularization',
        },
        {
            key: '1',
            label: 'Partial Day Request',
        },
    ];


    return <>
        <Space direction="vertical" className="w-full">
            <AttendanceRegularizationModal
                date={selectedDate ? moment(selectedDate).format('YYYY-MM-DD') : ''}
                onClose={() => setOpenModal(false)}
                open={openModal}
                onSubmit={(data) => {
                    console.log('Submitted data:', data);
                    setCurrentDate({ month: moment().format('MM'), year: moment().format('YYYY') });
                }}
            />
            <PartialDayRequestModal
                open={partialDayRequest}
                date={selectedDate ? moment(selectedDate).format('YYYY-MM-DD') : ''}
                onClose={() => setPartialDayRequest(false)}
                onSubmit={(data) => {
                    console.log('Partial Day Request Data:', data);
                }}
            />
            <DashboardStats onDateChange={(e) => setCurrentDate(e)} />
            <ReusableTable config={attendanceConfig} />
        </Space>
    </>
}

export default AttendanceLog;

